const VI_MESSAGE = {
  'login.error': 'Đăng nhập thất bại'
};

export default VI_MESSAGE;
